import { useEffect, useState } from 'react';
import { useTerm } from '@/shared/contexts/TermContext';
import termService from '@/shared/services/termService';
import { partsOfTermOf } from '@/shared/utils/partsOfTerm';

/**
 * The parts of term a request for `termCode` can name, or null while they
 * load. The current term comes from the term context; a draft resumed in
 * another term asks for that term. A term that cannot be read offers the
 * default, and the form's Other choice covers the rest.
 */
export function usePartsOfTerm(termCode) {
    const { currentTerm } = useTerm();
    const [fetched, setFetched] = useState(null);
    const fromContext = !!currentTerm && currentTerm.code === termCode;

    useEffect(() => {
        if (!termCode || fromContext) return undefined;
        let cancelled = false;
        const keep = (term) => {
            if (!cancelled) {
                setFetched({ code: termCode, parts: partsOfTermOf(term) });
            }
        };
        termService
            .getTermByCode(termCode)
            .then(keep)
            .catch(() => keep(null));
        return () => {
            cancelled = true;
        };
    }, [termCode, fromContext]);

    if (!termCode) return null;
    if (fromContext) return partsOfTermOf(currentTerm);
    return fetched?.code === termCode ? fetched.parts : null;
}

export default usePartsOfTerm;
